import { z } from 'my-zod'
import { vehiclesModel } from './vehicles-model'
import { CorporateFleetProgramTypeEnum, productLineOptions } from '../../internal'
import { attachmentModel } from '../../utilities/attachment'

export const vehicleCorporateFleetView = vehiclesModel
  .omit({ customAssetFamilyId: true, outfitterCustomAssetSerialNumber: true })
  .augment({
    programType: CorporateFleetProgramTypeEnum,
    attachments: attachmentModel.array().nullish(),
    attachmentsCount: z.number().nullish(),
    ibmiCustomerName: z.string().nullish(),
    ibmiDepartmentGroup: z.string().nullish(),
    ibmiDepartmentOwner: z.string().nullish(),
    isCheckInAvailable: z.number().nullish().optional(),
    productLine: z.enum(productLineOptions).nullish(),
    delegatedUser: z.string().nullish(),
    openBulletins: z.number().nullish(),
    openStopRides: z.number().nullish()
  })

export type vehicleCorporateFleetView = z.infer<typeof vehicleCorporateFleetView>
